module.exports = __webpack_public_path__ + "static/media/blueMarker.e5e52c3b.svg";